import type { ClientPaymentMethodRequest } from '@contracts/client/ClientPaymentMethodRequest';
import { ClientsClient } from '@src/clients/services/ClientsClient';
import { useMutation } from '@tanstack/react-query';

interface Props {
  clientId: string;
  onSuccess: () => void;
  onError: () => void;
}

export const useUpdatePaymentMethod = ({
  clientId,
  onSuccess,
  onError,
}: Props) => {
  const { mutate, isPending, isError } = useMutation({
    mutationFn: (data: ClientPaymentMethodRequest) => {
      return ClientsClient.updatePaymentMethod(clientId, data);
    },
    onSuccess,
    onError,
  });

  return {
    updatePaymentMethod: mutate,
    isLoading: isPending,
    isError,
  };
};
